import { render, staticRenderFns } from "./BackendLicenseSingle.vue?vue&type=template&id=684770ce&scoped=true&lang=pug"
import script from "./BackendLicenseSingle.vue?vue&type=script&lang=js"
export * from "./BackendLicenseSingle.vue?vue&type=script&lang=js"
import style0 from "./BackendLicenseSingle.vue?vue&type=style&index=0&id=684770ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684770ce",
  null
  
)

export default component.exports